import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';

import { isNullOrUndefined } from '@app/util/util';
import { Flight, FlightAmenitie, NewFlightItemVm } from '@app/entities/flight-results';
import { FlightClassTypes } from '@app/modules/shared/base-search-bar/entities/flight-class-types';
import { FlightCabin, FlightDetailCabinPayload } from '@shared/flight-itinerary/entities/cabin-types';

@Component({
  selector: 'app-flight-detail',
  templateUrl: './flight-detail.component.html',
  styleUrls: ['./flight-detail.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FlightDetailComponent {

  @Input() sector: NewFlightItemVm;
  @Input() index: number = 0;
  @Input() flightKeys: string = '';
  @Input() flightClass: FlightClassTypes;
  @Input() provider: string;
  @Input() isLoadingCabinDetail: boolean = false;
  @Input() cabinAmenities: FlightAmenitie[] = [];
  @Input() isMobile: boolean = true;
  @Input() isLoggedIn: boolean = false;
  @Input() isLoadingFlightCabin: boolean = false;
  @Input() flightCabinSelected: FlightCabin;
  @Input() isInternational: boolean;
  
  @Output() openCabinDetail: EventEmitter<FlightDetailCabinPayload> = new EventEmitter<FlightDetailCabinPayload>();

  constructor() { }

  public isScaleElement(item: number): boolean {
    return item < this.sector.Flights.length - 1;
  }

  get hasScales(): boolean {
    return this.sector.Flights.length - 1 > 0;
  }

  public getFlightKey(index: number): string {
    const keys = this.flightKeys ? this.flightKeys.trim().split(',') : [];
    return keys.length > 0 ? keys[index] : '';
  }

  public flightItem(item: number): Flight {
    return this.sector.Flights[item];
  }

  public nextFlightItem(item: number): Flight {
    return this.sector.Flights[item + 1] || {} as Flight;
  }

  public getCabinAmenitie(index: number): FlightAmenitie {
    const cabinIndex = this.getCabinIndex(this.sector.SectorNumber, this.index, index);
    const value = isNullOrUndefined(this.cabinAmenities) ? null : this.cabinAmenities.find(x => x.Index === cabinIndex);
    return value;
  }

  public getCabinIndex(sectorNumber: number, index: number, sectorIndex: number): number {
    return (sectorNumber * 100) + (sectorIndex * 10) + index;
  }

}
